var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"mask"}),_c('div',{staticClass:"content"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("页面不存在")]),_c('p',[_vm._v(" 抱歉，您访问的页面不存在，可能已被删除或链接地址有误。 ")]),_c('el-button',{attrs:{"type":"primary","round":""},on:{"click":_vm.goHome}},[_vm._v(" 返回首页 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }